module.exports = __webpack_public_path__ + "assets/paging-prev.bb0c9d95.svg";